<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required" nzFor="{{ toControlKey(wrapper.element) }}">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required" nzFor="{{ toControlKey(wrapper.element) }}" >{{ wrapper.element.name }}</nz-form-label>

		<nz-form-control [nzAutoTips]="wrapper.autoTips" [nzErrorTip]="errorTpl">
			<nz-input-group [nzSuffix]="verifyBtn">
				<input nz-input [formControlName]="toControlKey(wrapper.element)"
					[placeholder]="wrapper.element.description" [readonly]="readonly" />
			</nz-input-group>
			<ng-template #verifyBtn>
				<ng-container *ngTemplateOutlet="verifyButton"></ng-container>
			</ng-template>
		</nz-form-control>
	</nz-form-item>

	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips" [nzErrorTip]="errorTpl">
			<nz-input-group [nzSuffix]="verifyBtn">
				<input nz-input [formControlName]="toControlKey(wrapper.element)"
					[placeholder]="wrapper.element.description" [readonly]="readonly" />
			</nz-input-group>
			<ng-template #verifyBtn>
				<ng-container *ngTemplateOutlet="verifyButton"></ng-container>
			</ng-template>
		</nz-form-control>
	</nz-form-item>
</div>

<!-- Shared verify button template -->
<ng-template #verifyButton>
	<button nz-button nzType="link" nzSize="small" [nzLoading]="isVerifying" (click)="verify()" style="padding: 0 4px;">
		<ng-container [ngSwitch]="verificationStatus">
			<span *ngSwitchCase="'Living'" nz-icon nzType="check-circle" nzTheme="fill" style="color: #52c41a;"></span>
			<span *ngSwitchCase="'Deceased'" nz-icon nzType="close-circle" nzTheme="fill"
				style="color: #ff4d4f;"></span>
			<span *ngSwitchCase="'Error'" nz-icon nzType="warning" nzTheme="fill" style="color: #faad14;"></span>
			<span *ngSwitchDefault>Verify</span>
		</ng-container>
	</button>
	<nz-tag *ngIf="verificationStatus === 'Living'" nzColor="success" style="margin-left: 4px;">Living</nz-tag>
	<nz-tag *ngIf="verificationStatus === 'Deceased'" nzColor="error" style="margin-left: 4px;">Deceased</nz-tag>
	<nz-tag *ngIf="verificationStatus === 'Error'" nzColor="warning" style="margin-left: 4px;">Error</nz-tag>
</ng-template>

<!-- Shared error tip template -->
<ng-template #errorTpl let-control>
	<ng-container *ngIf="control.hasError('deceased')">
		Person is deceased.
	</ng-container>
</ng-template>
